/**
 * Fallback : décodage des embeds côté navigateur.
 *
 * Normalement les <a data-type="embed" data-code="..."> sont décodés côté
 * serveur par Contenu::parseContent() (base64_decode + remplacement par un
 * <div>). Si ce traitement n'a pas eu lieu, ce module prend le relais : il
 * décode le data-code (base64) et injecte le HTML obtenu, mais seulement
 * quand l'embed entre dans la fenêtre (lazy via IntersectionObserver).
 */
Sofoot.modules.embeds = (() => {
    let observer;

    // base64 -> chaîne HTML (gère l'UTF-8 des caractères accentués)
    function decoder(b64) {
        try {
            const binaire = atob(b64);
            const octets = Uint8Array.from(binaire, c => c.charCodeAt(0));
            return new TextDecoder('utf-8').decode(octets);
        } catch (e) {
            console.error('embeds: décodage impossible', e);
            return null;
        }
    }

    function injecter(lien) {
        const html = decoder(lien.dataset.code);
        if (html === null) return;

        // on remplace le <a> par un <div>, comme le fait parseContent côté back
        const div = document.createElement('div');
        div.dataset.type = 'embed';
        div.innerHTML = html;
        lien.replaceWith(div);

        // innerHTML n'exécute pas les <script> : on les recrée pour qu'ils tournent
        // (embed.js d'instagram/tiktok/twitter notamment)
        div.querySelectorAll('script').forEach(vieux => {
            const neuf = document.createElement('script');
            for (const attr of vieux.attributes) {
                neuf.setAttribute(attr.name, attr.value);
            }
            neuf.textContent = vieux.textContent;
            vieux.replaceWith(neuf);
        });

        // si l'API instagram est déjà présente, on relance le rendu du blockquote
        if (window.instgrm?.Embeds?.process) {
            window.instgrm.Embeds.process();
        }
    }

    return {
        start() {
            const liens = document.querySelectorAll('a[data-type="embed"][data-code]');
            if (!liens.length) return;

            if (!('IntersectionObserver' in window)) {
                liens.forEach(injecter);
                return;
            }

            observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (!entry.isIntersecting) return;
                    observer.unobserve(entry.target);
                    injecter(entry.target);
                });
            }, { rootMargin: '200px' });

            liens.forEach(lien => observer.observe(lien));
        }
    };
})();
